import { default as TapisProvider } from './TapisProvider';

export default TapisProvider;
